


<form-nueva-solicitud [paciente]="paciente" size="sm" [tipoSolicitud]="tipoSolicitud" (operacionFinalizada)="returnForm()">
</form-nueva-solicitud>
